import { atom } from 'jotai';

export const visibleFacetsAtom = atom([]);
export const openFacetsAtom = atom({});
export const sidebarState = atom();
export const liveSearchState = atom();
